import Vue from "vue";
import App from "./App.vue";
import { sync } from "vuex-router-sync";
import router from "./router";
import store from "./store";
import vueAuthConfig from "../config/vueAuthConfig";
import Buefy from "buefy";
import VueGtag from "vue-gtag";
import VueLodash from "vue-lodash";
import lodash from "lodash";
import VueAuth from "@websanova/vue-auth";
import VeeValidate, { Validator } from "vee-validate";
import VueScrollTo from "vue-scrollto";
import Progress from "vue-multiple-progress";
import sanitizeHTML from "sanitize-html";
import pluralize from "pluralize"; // TODO:
import moment from "moment-timezone/builds/moment-timezone-with-data-2012-2022.js";
import * as Sentry from "@sentry/browser";
import { Severity } from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
import "./plugins/axios";
import "formdata-polyfill";
import "typeface-lato/index.css";
import "@mdi/font/css/materialdesignicons.min.css";
import "./assets/sass/app.sass";

const DATE_FORMAT = "YYYY-MM-DD";
Vue.prototype._app_chart_colors_multiple = {
  navy: "#3D579E",
  tangerine: "#F25200",
  purple: "#9F5196",
  orange: "#F29626",
  teal: "#1F9E9E",
  yellow: "#EDC947"
};
Vue.prototype._app_chart_two_color = {
  steps: "#2285ff",
  activities: "#56c0e2"
};
Vue.prototype.moment = moment;
Vue.prototype.sanitize = sanitizeHTML;
Vue.prototype.pluralize = pluralize;

// Vue.use(VueReCaptcha, { siteKey: "6LerqpkUAAAAAMbuVYy0CSKapT0nlaJQoY_s-7E8" });
Vue.use(VeeValidate);
Vue.use(
  VueGtag,
  {
    config: { id: "G-W81V148760" }
  },
  router
);
Vue.use(VueScrollTo);
Vue.use(VueAuth, vueAuthConfig);
Vue.use(VueLodash, { lodash });
Vue.use(Buefy, {
  defaultDateFormatter: date => moment(date).format(DATE_FORMAT)
});
Vue.use(Progress);
Vue.config.productionTip = false;

// Sync vue-router's current $route as part of vuex store's state
sync(store, router);

if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_URL,
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
    environment:
      process.env.VUE_APP_ENV === "debug" ? "Debug" : process.env.NODE_ENV,
    beforeSend(event) {
      if (event.level === Severity.Error || event.level === Severity.Fatal) {
        return event;
      }

      return null;
    }
  });
}

// Custom validation rules
Validator.extend("gt", {
  getMessage: (field, otherValue) =>
    field + " must be greater than " + otherValue,
  validate: (value, [otherValue]) => {
    return value > otherValue;
  },
  options: {
    hasTarget: true,
    immediate: false
  }
});
Validator.extend("lt", {
  getMessage: (field, otherValue) => field + " must be less than " + otherValue,
  validate: (value, [otherValue]) => {
    return value < otherValue;
  },
  options: {
    hasTarget: true,
    immediate: false
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

const placeholder = document.querySelectorAll(".placeholder-wt-logo")[0];

setTimeout(() => {
  placeholder.style.display = "none";
}, 1000);
